import { appendQueryParams } from './appendQueryParams';
import { getLocation } from './getLocation';
export function appendAndReplaceQueryParams(url, params, isEncoded, disableEncodedOutput) {
    if (!url || !params) {
        return url;
    }
    var newParams = {};
    var location = getLocation(url);
    if (!location) {
        return url;
    }
    var protocol = location.protocol, hostname = location.hostname, path = location.path, search = location.search, hash = location.hash;
    if (search[0] === '?') {
        var queryList = search.substring(1).split('&');
        queryList.forEach(function (q) {
            var s = q.split('=');
            if (!isEncoded) {
                newParams[s[0]] = s[1];
            }
            else {
                newParams[decodeURIComponent(s[0])] = decodeURIComponent(s[1]);
            }
        });
    }
    for (var field in params) {
        newParams[field] = params[field];
    }
    return appendQueryParams(protocol + '//' + hostname + path + hash, newParams, disableEncodedOutput);
}
//# sourceMappingURL=appendAndReplaceQueryParams.js.map